import { motion } from "framer-motion"
import { motionVariants } from "../Common/GlobalVars"
import { RatingItemProps } from "./constants"
import Image from "next/image"
import Link from "next/link"
import Review from "./Review"
import { useState } from "react"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import Cookies from "js-cookie"
import Lightbox from "yet-another-react-lightbox";
import NextJsImage from "../Utils/NextJsImage";
import "yet-another-react-lightbox/styles.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";


interface RatingProps {
  rating: RatingItemProps;
  slug: string;
}

const Rating = (props: RatingProps) => {
  const { rating, slug } = props;
  const viewport = Cookies.get('viewport');
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState<Array<{ src: string }>>([]);

  const render_rating = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => {
      if (i < rating) {
        return (
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/star.png"}
            alt="star icon"
            width={16}
            height={16}
            quality={100}
            key={i}
          />
        )
      } else if (i < rating + 1) {
        return (
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/half-star.png"}
            alt="half star icon"
            width={16}
            height={16}
            quality={100}
            key={i}
          />
        )
      } else {
        return (
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/empty-star.png"}
            alt="empty star icon"
            width={16}
            height={16}
            quality={100}
            key={i}
          />
        )
      }
    });
  }

  return (
    <>
      <motion.div
        className="flex items-start justify-between w-full mb-8 px-7 md:px-0 md:items-center font-poppins md:mb-6"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        variants={motionVariants}
      >
        <div className="text-black text-sm md:text-[18px] font-bold w-2/3">
          Ulasan Produk
          <div className="flex flex-wrap items-center mt-2 space-x-2">
            <p className="text-base font-medium text-black">{rating.review_rating.toFixed(1)}/5</p>
            {render_rating(rating.review_rating)}
            <p className="!ml-0 md:!ml-2 text-sm font-normal text-black md:text-xs mt-2 md:mt-0">({rating.counts} Reviews)</p>
          </div>
        </div>
        <Link href={"./" + slug + "/review"}>
          <div className="flex items-center space-x-2 text-xs text-black">
            <p>Lihat semua</p>
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/arrow_right.png"}
              alt="arrow right icon"
              width={8}
              height={8}
              quality={100}
            />
          </div>
        </Link>
      </motion.div>
      <motion.div
        className="mt-6"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        variants={motionVariants}
      >
        <Swiper
          slidesPerView={viewport === "desktop" ? 3 : 1.2}
          spaceBetween={viewport === "desktop" ? 32 : 16}
          centeredSlides={viewport === "desktop" ? false : true}
          modules={[Pagination, Navigation]}
          speed={700}
          navigation={true}
          pagination={viewport === "desktop" ? false : {
            clickable: true,
            enabled: true,
          }}
          className="!pb-10 rating-swiper"
        >
          {
            rating.review_list.map((review, index) => (
              <SwiperSlide key={index}>
                <Review review={review} full_review={false} setImages={setImages} setGalleryOpen={setOpen} />
              </SwiperSlide>
            ))
          }
        </Swiper>
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          styles={{ root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .7)" } }}
          controller={{
            closeOnPullUp: true,
            closeOnPullDown: true,
            closeOnBackdropClick: true,
          }}
          slides={images}
          render={{
            slide: NextJsImage,
            buttonPrev: images.length > 1 ? undefined : () => null,
            buttonNext: images.length > 1 ? undefined : () => null,
          }}
        />
      </motion.div>
    </>
  )
}

export default Rating
